import type Position from '@heathmont/moon-core-tw/lib/tooltip/private/types/Position';

const useTournamentTooltip = () => {
  const getTooltipPosition = (
    tooltipPosition?: Position,
    isCurrentTournaments?: boolean,
  ) => {
    if (tooltipPosition) {
      return tooltipPosition;
    }
    if (isCurrentTournaments) {
      return 'bottom-end';
    }
    return 'bottom-center';
  };
  return { getTooltipPosition };
};

export default useTournamentTooltip;
